module.exports = __webpack_public_path__ + "static/media/IMG_6592.da3dc3bf.jpg";